<div class="igntr-theme bg-[--background-color]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px] pb-12"
  >
    <app-page-hero
      [title]="'tenants'"
      [description]="
        filteredTenants.length +
        ' ' +
        ('workspaces' | transloco) +
        ' · ' +
        totalUsers +
        ' ' +
        ('usersTotal' | transloco)
      "
      showSearchBar
      showLayoutSwitch
      [newButton]="{ route: '/tenants/new', text: 'newTenant' }"
      (searchEmitter)="searchQuery = $event; applyFilter()"
      (layoutSwitchEmitter)="viewMode = $event; onSelectionChange([])"
    >
      <p-splitButton
        label="{{ 'actions' | transloco }}"
        [model]="disableActions"
        [disabled]="selectedIds.length === 0"
        class="disable-actions-button grow md:grow-0"
      ></p-splitButton>

      <button
        type="button"
        class="ref-archived-toggle"
        [class.is-active]="showDeactivated"
        (click)="toggleDeactivated()"
        [title]="'showDeactivatedHint' | transloco"
        [attr.aria-label]="'showDeactivated' | transloco"
      >
        <igntr-icon [name]="showDeactivated ? 'eye' : 'eyeOff'"></igntr-icon>
        <span class="hidden sm:inline">
          {{ "showDeactivated" | transloco }}
        </span>
      </button>
    </app-page-hero>

    <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
    <app-tenant-list
      *ngIf="!(repo.isLoading$ | async)"
      style="width: 100%"
      [innerWidth]="innerWidth"
      [viewMode]="viewMode"
      [tenants]="filteredTenants"
      [selectedIds]="selectedIds"
      (selectedIdsChange)="onSelectionChange($event)"
      [isDeleteDisabled]="
        !(auth.isSuperAdmin$ | async) && !(auth.isPartnerManager$ | async)
      "
      (delete)="delete($event)"
      (toggleDisabled)="toggleDisabled($event)"
      (clone)="handleCloneClick($event); (refreshData)"
    ></app-tenant-list>

    <div
      class="flex items-center justify-between mt-6 text-[14px] !text-slate-500"
      *ngIf="filteredTenants.length >= 0"
    >
      <div class="font-mono tabular-nums">
        Showing {{ filteredTenants.length }} of {{ allTenants.length }}
      </div>
      <div class="flex items-center gap-1">
        <button class="px-2 py-1 rounded-md hover:bg-slate-100">‹</button
        ><span class="font-mono tabular-nums px-1">1 / 1</span
        ><button class="px-2 py-1 rounded-md hover:bg-slate-100">›</button>
      </div>
    </div>
  </div>
</div>

<p-button
  class="flex min-[576px]:hidden mobile-add-button"
  icon="pi pi-plus"
  [routerLink]="['/tenants/new']"
/>
